import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, shareReplay} from 'rxjs';

import { GlobalVariable } from '../../shared/global.settings';
import { IAmazonDigitalOrderListEntry, IAmazonBookDetails } from '../../_models';

@Injectable({
  providedIn: "root"
})
export class AmazonUpdateService {
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  [x: string]: any;
  private amazonApiUrl = GlobalVariable.AMAZON_API_BASE;


  constructor(
    private http: HttpClient
  ) { }

  /**
   * 
   * @returns an array of IAmazonDigitalOrderListEntry ordered in the last 6 months
   */
  getAmazonBookList$(): Observable<IAmazonDigitalOrderListEntry[]> {
    const bookList$ = this.http.get<IAmazonDigitalOrderListEntry[]>(this.amazonApiUrl + '/amazon-book-list');

    return bookList$;
    
  }

  /**
   * 
   * @param year : four digit year
   * @returns an array of IAmazonDigitalOrderListEntry ordered during that calendar year
   */
  getAmazonBookListByYear$(year: string): Observable<IAmazonDigitalOrderListEntry[]> {

    return this.http.get<IAmazonDigitalOrderListEntry[]>(this.amazonApiUrl + '/amazon-book-list/' + year)
      .pipe(
        shareReplay()
      );
  }

  /**
   * 
   * @param amazon_id: an Amazon Internal item identifier
   * @returns the details for that item
   */
  getAmazonBookDetail$(amazon_id: string): Observable<IAmazonBookDetails> {
    console.log(this.amazonApiUrl + '/amazon-book-details/' + amazon_id);
    return this.http.get<IAmazonBookDetails>(this.amazonApiUrl + '/amazon-book-details/' + amazon_id)
      .pipe(
        shareReplay()
      );
  }

}



